module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "单位名称",
      "input-align": "right",
      "error-message-align": "right",
      "left-icon": "question-o",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('danwei')
      }
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "label": "考级时间",
      "input-align": "right",
      "error-message-align": "right",
      "placeholder": "请选择考级时间",
      "rules": [{
        required: true,
        message: '请选择考级时间'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDate = true
      }
    },
    model: {
      value: (_vm.formData.datetitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "datetitle", $$v)
      },
      expression: "formData.datetitle"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.province ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "省市地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("考级点如需申报绿星级及以上星级的考级，需要获得考级中心授权")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入考级要求'
      }],
      "error-message-align": "right",
      "label": "考级要求",
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入考级要求"
    },
    model: {
      value: (_vm.formData.kaojiyaoqiu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kaojiyaoqiu", $$v)
      },
      expression: "formData.kaojiyaoqiu"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入注意事项'
      }],
      "error-message-align": "right",
      "label": "注意事项",
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入注意事项"
    },
    model: {
      value: (_vm.formData.zhuyishixiang),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zhuyishixiang", $$v)
      },
      expression: "formData.zhuyishixiang"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存\n      ")])], 1)], 1), _vm._v(" "), _c('KaoguanPicker', {
    attrs: {
      "show": _vm.showKaoguanPicker,
      "limit": 5,
      "defaultValue": _vm.formData.kaoguan
    },
    on: {
      "onChange": _vm.onKaoguanChange,
      "onClose": function($event) {
        _vm.showKaoguanPicker = false
      },
      "onConfirm": _vm.onKaoguanConfirm
    }
  }), _vm._v(" "), _c('JianduPicker', {
    attrs: {
      "show": _vm.showJianduPicker,
      "limit": 1,
      "defaultValue": _vm.formData.jiandu
    },
    on: {
      "onChange": _vm.onJianduChange,
      "onClose": function($event) {
        _vm.showJianduPicker = false
      },
      "onConfirm": _vm.onJianduConfirm
    }
  }), _vm._v(" "), _c('CenterPicker', {
    attrs: {
      "show": _vm.showCenterPicker,
      "limit": 1,
      "defaultValue": _vm.formData.extra_center
    },
    on: {
      "onChange": _vm.onCenterChange,
      "onClose": function($event) {
        _vm.showCenterPicker = false
      },
      "onConfirm": _vm.onCenterConfirm
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "title": "选择年月日",
      "type": "date",
      "default-date": new Date((_vm.formData.datetitle ? _vm.formData.datetitle : "").replace(/-/g, "/")),
      "min-date": _vm.minDate
    },
    on: {
      "cancel": function($event) {
        _vm.showDate = false
      },
      "confirm": _vm.onDateConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b83f7664","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyFormMatch.vue
// module id = 2566
// module chunks = 0